import {Middleware} from '@reduxjs/toolkit';
import {signalRService} from '../../services/signalRService';
import {receiveSignalREvent, setRedactionEvents} from '../slice/signalrSlice';
import {REDACTION_SIGNALR_TYPE} from '../../shared/constants';
import {NOTIFICATION_URL, NOTIFICATIONS_API_KEY} from '../../config/env';

export const subscribeToGroup = (groupName: string) => ({
  type: 'signalr/subscribeToGroup',
  payload: groupName,
});

export const unsubscribeFromGroup = (groupName: string) => ({
  type: 'signalr/unsubscribeFromGroup',
  payload: groupName,
});

let receiveMessageRegistered = false;

export const signalRMiddleware: Middleware =
  (storeAPI) => (next) => async (action: any) => {
    const result = next(action);

    if (action.type === 'signalr/subscribeToGroup') {
      try {
        await signalRService.startConnection(
          `${NOTIFICATION_URL}/hub/notifications`,
          NOTIFICATIONS_API_KEY
        );

        if (!receiveMessageRegistered) {
          signalRService.on('ReceiveMessage', (data: any) => {
            if (data?.type === REDACTION_SIGNALR_TYPE) {
              storeAPI.dispatch(
                setRedactionEvents({
                  type: 'ReceiveMessage',
                  payload: data,
                })
              );
            } else {
              storeAPI.dispatch(
                receiveSignalREvent({
                  type: 'ReceiveMessage',
                  payload: data,
                })
              );
            }
          });

          receiveMessageRegistered = true;
        }

        const groupName = action.payload;

        await signalRService.subscribeToGroup(groupName);
      } catch (err) {
        console.error(`Failed to subscribe to group ${action.payload}`, err);
      }
    }

    if (action.type === 'signalr/unsubscribeFromGroup') {
      try {
        const groupName = action.payload;

        await signalRService.unsubscribeFromGroup(groupName);
      } catch (err) {
        console.error(
          `Failed to unsubscribe from group ${action.payload}`,
          err
        );
      }
    }

    if (action.type === 'auth/logout') {
      try {
        signalRService.off('ReceiveMessage');

        receiveMessageRegistered = false;

        await signalRService.stopConnection();
      } catch (err) {
        console.error('Error stopping SignalR connection', err);
      }
    }

    return result;
  };
